const getCabinetBoxName = (sharedFeatureName = "") => {
  return sharedFeatureName.includes("/")
    ? sharedFeatureName.split("/")[0].trim()
    : sharedFeatureName.trim();
};

// Matches the same cabinet SKU/type inside another parent color's related features.
export function getCabinetSimilarFeatureFromAnotherColor(features, currentShapeDbFeature) {
  if (!Array.isArray(features) || !currentShapeDbFeature?.sharedFeatureName) {
    return null;
  }

  const cabinetBoxName = getCabinetBoxName(currentShapeDbFeature.sharedFeatureName);
  const exactMatch = features.find(feature => feature.sharedFeatureName === cabinetBoxName);

  return exactMatch || features.find(feature => (
    feature.sharedFeatureName && feature.sharedFeatureName.includes(cabinetBoxName)
  )) || null;
}
